// extracted by mini-css-extract-plugin
module.exports = {"qqtNav":"Nav_qqtNav__2rfK_","qqtLogo":"Nav_qqtLogo__3zoSY"};